import Container from "./../ui/container";
import Heading from "./../ui/heading";
import PageBreadcrumbs from "./../SharedComponent/page-breadcrumbs";
import { SERVICES } from "./../constant/services";
import { Link } from "react-router-dom";
import React, { useEffect } from "react";
import "./../css/services.css";

const ServicesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <PageBreadcrumbs
        title='Services'
        breadcrumbs={{
          currentPage: "Services",
          items: [
            {
              name: "Home",
              href: "/",
            },
          ],
        }}
      />
      <div className='services-section'>
        <Container>
          <Heading variant='H2' className='services-heading'>
            Services
          </Heading>
          <div className='services-grid'>
            {SERVICES.map((item) => (
              <Link
                to={`/services/${item.slug}`}
                key={item.title}
                className='services-card'
              >
                <div>{item.icon}</div>
                <div className='services-divider'></div>
                <span className='services-title'>{item.title}</span>
              </Link>
            ))}
          </div>
        </Container>
      </div>
    </>
  );
};
export default ServicesPage;
